import { EMAIL_VALIDATE } from "@constants";
import * as Yup from "yup";
export const validateSchema = Yup.object().shape({
  fullname: Yup.string()
    .required("Full Name is required")
    .min(5, "Full Name require minimum of 5 characters")
    .max(50, "Full Name require maximum of 50 characters"),
  email: Yup.string()
    .required("Email Address is required")
    .matches(EMAIL_VALIDATE, "Invalid email format"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must contains at least 8 characters")
    .matches(
      /^(?=.*[a-z])/,
      "Password must contains at least 1 lowercase character"
    )
    .matches(
      /^(?=.*[A-Z])/,
      "Password must contains at least 1 uppercase character"
    )
    .matches(
      /^(?=.*[0-9])/,
      "Password must contains at least 1 digit character"
    )
    .matches(
      /^(?=.*[!@#$%^&*])/,
      "Password must contains at least 1 special character (!@#$%^&*)"
    )
    .max(255, "Password require maximum of 255 characters"),
  confirmPassword: Yup.string()
    .required("You need to confirm your password")
    .oneOf([Yup.ref("password")], "Your passwords do not match."),
});
export const initialValues = {
  fullname: "",
  email: "",
  password: "",
  confirmPassword: "",
};
